import { SidebarMainSection } from '@/components/sidebar/SidebarMainSection';
import { FC } from 'react';

export const CreditCheckerLinks: FC = () => {
  return (
    <>
      <SidebarMainSection
        sectionUrlIdentifier="creditcheck"
        title={'Credit Check'}
        to={'/creditcheck'}
      ></SidebarMainSection>
    </>
  );
};
